<app-form-modal-dialog
    #modal
    [submit]="form.submit.bind(form)"
>
    <div title>
        Vestiging hernoemen
    </div>
    <div body>
        <app-establishment-form
            #form
            [establishment]="establishment"
            (submitted)="updateEstablishment($event)"
        />
    </div>
    <div button-submit>
        Opslaan
    </div>
</app-form-modal-dialog>
